var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('transition',{attrs:{"name":"fade"}},[(_vm.infoBoxVisible)?_c('div',{staticClass:"infoBox",class:_vm.$store.state.personal.theme},[_vm._v(_vm._s(_vm.$store.state.infoBoxText))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }